import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Fragment, useMemo } from 'react';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import SectionHeading from '../SectionHeading';
import { RouterLink } from '../AcademyLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MostPopularCertificatesHeader = ({
  numCompletedCertificates
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const certificatesCompletedCount = useMemo(() => /*#__PURE__*/_jsx(RouterLink, {
    onClick: () => UsageTracker.track('interaction', {
      action: 'most-popular-certificates-certificates-completed-clicked'
    }),
    to: "/mylearning/completed?awardType=ONLY_SHOW_CERTIFICATE_COURSES",
    children: !isMobile && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.mostPopularCertificates.certificatesCompleted",
      options: {
        numCertificates: numCompletedCertificates
      }
    })
  }), [isMobile, numCompletedCertificates]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "start",
      justify: "between",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        icon: "certification",
        subText: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `learningCenter.mostPopularCertificates.genericSubtitle`
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.genericTitle"
        })
      }), !isMobile && /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex'
        },
        children: [certificatesCompletedCount, /*#__PURE__*/_jsxs("div", {
          style: {
            display: 'none'
          },
          children: [/*#__PURE__*/_jsx(UIIconButton, {
            size: "xs",
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "left"
            })
          }), /*#__PURE__*/_jsx(UIIconButton, {
            size: "xs",
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "right"
            })
          })]
        })]
      })]
    }), isMobile && /*#__PURE__*/_jsx("div", {
      className: "m-bottom-2",
      children: certificatesCompletedCount
    })]
  });
};
export default MostPopularCertificatesHeader;